module.exports = __webpack_public_path__ + "img/asset-account-card.33e6cff0.svg";